var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("input", {
    staticClass:
      "w-full border mt-6 border-gray-900 rounded-lg p-3 text-lg font-medium text-gray-900 placeholder-gray-900 focus:outline-none focus:border-yellow focus:ring focus:ring-yellow",
    class: _vm.classes,
    attrs: {
      id: _vm.id,
      name: _vm.name,
      type: _vm.type,
      placeholder: _vm.placeholder,
      disabled: _vm.disabled,
    },
    domProps: { value: _vm.value },
    on: {
      input: _vm.handleInput,
      keypress: _vm.checkSymbol,
      blur: function ($event) {
        return _vm.$emit("blur")
      },
      keyup: function ($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
        )
          return null
        return _vm.$emit("enter")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }